<script>
import feather from 'feather-icons';
import FooterCopyright from './FooterCopyright.vue';
import { socialLinks } from '../../data/socialLinks';

export default {
	components: { FooterCopyright },
	data() {
		return {
			socials: socialLinks,
		};
	},
	mounted() {
		feather.replace();
	},
	updated() {
		feather.replace();
	},
};
</script>

<template>
	<div class="max-w-[1440px] mx-auto px-5 sm:px-8 lg:px-14">
		<div class="pt-20 pb-8 mt-24 border-t border-line">
			<!-- Footer social links -->
			<div
				class="flex flex-col justify-center items-center mb-12 sm:mb-16"
			>
				<p
					class="font-mono-ui text-xs tracking-[0.22em] uppercase text-ink-muted mb-6"
				>
					Follow us
				</p>
				<ul class="flex gap-3 sm:gap-4">
					<a
						v-for="social in socials"
						:key="social.id"
						:href="social.url"
						target="__blank"
						class="text-ink-muted hover:text-ink cursor-pointer rounded-lg bg-surface border border-line hover:border-line-strong p-3.5 duration-300"
					>
						<i
							:data-feather="social.icon"
							class="w-5 sm:w-6 h-5 sm:h-6"
						></i>
					</a>
				</ul>
			</div>

			<!-- Footer copyright -->
			<FooterCopyright />
		</div>
	</div>
</template>

<style scoped></style>
